import { RG_TYPE } from '../../types/rg-type.js';
import { DefaultCeiling } from './default-ceiling.js';
import { DefaultFloor } from './default-floor.js';
import { DefaultWall } from './default-wall.js';

const DefaultEntrance = {
    type: RG_TYPE.Entrance,
    color: '#C2C2D3',
    size: [3.875, 2.5, 7.5],
    anchor: [0.5, 0, 0.5],
    name: 'entrance',
    data: { level: -1, levelId: '', muscleID: '' },
    children: [
        { ...DefaultWall, pos: [0, 0, -3] },
        { ...DefaultWall, pos: [0, 0, 3], rot: [180, 0, 180] },
        { ...DefaultWall, pos: [-3, 0, 0], rot: [0, 90, 0] },
        { ...DefaultWall, pos: [3, 0, 0], rot: [0, -90, 0] },
        { ...DefaultCeiling },
        { ...DefaultFloor }
    ]
};

export { DefaultEntrance };
//# sourceMappingURL=default-entrance.js.map
